import { $, onReady, isMobile, reducedMotion } from '../nth-ms26-core/js/env';
import { createParticles } from '../nth-ms26-core/js/particles';
import { initHomeKv } from './js/kv';

onReady(() => {
  const frame = $('#trang-chu');
  if (!frame) return;
  initHomeKv(frame);
  if (isMobile()) return;

  // tuyết rơi chỉ chạy khi đang ở màn Trang chủ
  const fx = createParticles($('[data-particles]', frame));
  const sync = () => (frame.classList.contains('is-active') && !document.hidden ? fx.start() : fx.stop());
  document.addEventListener('nth:frame', sync);
  document.addEventListener('visibilitychange', sync);

  // parallax nhẹ theo chuột (rAF gộp sự kiện, chỉ đổi transform)
  const layer = $('[data-parallax]', frame);
  if (!layer || reducedMotion.matches) return;
  let raf = 0;
  window.addEventListener('pointermove', (e) => {
    if (raf || !frame.classList.contains('is-active')) return;
    raf = requestAnimationFrame(() => {
      raf = 0;
      const x = (e.clientX / window.innerWidth - 0.5) * -18;
      const y = (e.clientY / window.innerHeight - 0.5) * -12;
      layer.style.setProperty('--px', `${x.toFixed(1)}px`);
      layer.style.setProperty('--py', `${y.toFixed(1)}px`);
    });
  }, { passive: true });
});
